import '@webscopeio/react-textarea-autocomplete/style.css';
import './TextAreaWithAutoComplete.scss';
import ReactTextareaAutocomplete, { ItemComponentProps } from '@webscopeio/react-textarea-autocomplete';
import { observer } from 'mobx-react-lite';
import { ChangeEvent, ReactElement, useEffect, useRef } from 'react';

interface ITextAreaWithAutocompleteProps {
  value?: string | number;
  maxLength?: number;
  onChange(value: string): void;
  autofocus?: boolean;
  counter?: boolean;
  autocompleteOptions: string[];
}

export const TextAreaWithAutocomplete = observer((props: ITextAreaWithAutocompleteProps): ReactElement => {
  const inputRef = useRef<HTMLTextAreaElement>(undefined);

  useEffect((): void => {
    if (props.autofocus) {
      setTimeout(() => inputRef.current?.focus(), 0);
    }
  }, []);

  const getInputReference = (textarea: HTMLTextAreaElement): void => {
    inputRef.current = textarea;
  };

  const itemComponent = (i: ItemComponentProps<string>): ReactElement => <div className='text-area-with-autocomplete-item'>{i.entity}</div>;

  const loadingComponent = (): ReactElement => <div />;

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>): void => {
    let value = e.target.value;
    if (props.maxLength) {
      value = value.substring(0, props.maxLength);
    }
    props.onChange(value);
  };

  const maxLength = props.maxLength === undefined ? 100 : props.maxLength;

  return (
    <div className='text-area-with-autocomplete'>
      <ReactTextareaAutocomplete<string>
        innerRef={getInputReference}
        onChange={handleChange}
        loadingComponent={loadingComponent}
        maxLength={maxLength}
        value={props.value}
        minChar={0}
        trigger={{
          '#': {
            component: itemComponent,
            dataProvider: (token) => props.autocompleteOptions.filter((text) => text.toLowerCase().startsWith(token.toLowerCase())),
            output: (item) => item,
          },
        }}
      />
      {props.counter && (
        <div className='text-right'>
          <small>
            {(props.value || '').toString().length}/{maxLength}
          </small>
        </div>
      )}
    </div>
  );
});
